<template>
  <BaseSelect ref="select" placeholder="选择语法" :label="selectLabel" width="100%" 
    :clearable="this.value > 0"
    @clear="handleClear">
    <GrammarInlineList>
      <template #operate="column">
        <el-button @click="handleSelect(column.row)" type="text" size="small">选择</el-button>
      </template>
    </GrammarInlineList>
  </BaseSelect>
</template>

<script>
import BaseSelect from '@/components/BaseSelect'
import GrammarInlineList from './GrammarInlineList'

export default {
  name: 'GrammarSelect',
  components: { BaseSelect, GrammarInlineList },
  props: {
    value: [Number, String],
    onSelect: {
      type: Function
    },
  },
  data () {
    return {
      selectLabel: '',
      currentValue: null
    }
  },
  watch: {
    value() {
      this.updateSelectLabel()
    }
  },
  mounted () {
    this.updateSelectLabel()
  },
  methods: {
    updateSelectLabel() {
      if (this.value === this.currentValue) {
        return
      }
      this.currentValue = this.value
      if (!this.value) {
        this.selectLabel = ''
        return
      }
      this.selectLabel = 'Loading...'
      this.$http.get(this.$urls.grammar_view, {params: {id: this.value}}).then(res => {
        this.selectLabel = `${res.data.text} (L${res.data.level} ID:${res.data.id} ${res.data.memo || ''})`
      })
    },
    handleSelect(item) {
      this.currentValue = item.id
      this.selectLabel = `${item.text} (L${item.level} ID:${item.id} ${item.memo || ''})`
      this.$emit('input', item.id)
      this.onSelect(item)
      this.$refs.select.hidePopover()
    },
    handleClear() {
      this.currentValue = 0
      this.selectLabel = ''
      this.$emit('input', 0)
    }
  }
}
</script>